import dashboardRecentsReducer from './reducers';

export { default as dashboardRecentsActions } from './actions';
export { default as dashboardRecentsSelectors } from './selectors';

export default dashboardRecentsReducer;
